import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as firebase from "firebase";
import BigForm from "../../components/BigForm";
import "./Login.css";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      showErr: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email, password } = this.state;
    const auth = firebase.auth();

    auth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        window.location = "/";
      })
      .catch(() => this.setState({ showErr: true }));
  }

  render() {
    return (
      <BigForm
        header="Login"
        errorText={this.state.showErr ? "Incorrect email or password" : ""}
      >
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">
              Email:
              <input
                className="form-control"
                type="text"
                name="email"
                value={this.state.email}
                onChange={this.handleChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="password">
              Password:
              <input
                className="form-control"
                type="password"
                name="password"
                value={this.state.password}
                onChange={this.handleChange}
              />
            </label>
          </div>
          <input type="submit" value="Login" />
        </form>
        <div className="createAccount">
          Don&apos;t have an account? <Link to="/user/new">Create one</Link>
        </div>
      </BigForm>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js